licenses-notices-1 = BestCraft is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
licenses-notices-2 = BestCraft is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
licenses-notices-3 = You should have received a copy of the GNU Affero General Public License along with BestCraft. If not, see https://www.gnu.org/licenses/.
copyright-notices = 
    Copyright 2025 Tnze. All Rights Reserved.
    Referenced FFXIV related resources: Copyright © 2010 - 2025 SQUARE ENIX CO., LTD.

level = Lv
recipe-level = Recipe Lv
class-job-level = Class Job Lv
craftsmanship = 作業精度
control = 加工精度
craft-point = CP
progress = 工数
quality = 品質
durability = 耐久
steps = TURN
condition = 状態
difficulty = 必要工数
initial-quality = 初期品質

meals = 調理品
medicines = 薬品

carpenter = 木工師
blacksmith = 鍛冶師
armorer = 甲冑師
goldsmith = 彫金師
leatherworker = 革細工師
weaver = 裁縫師
alchemist = 錬金術師
culinarian = 調理師

default = デフォルト
common = 一般的な
custom = カスタム { $id }

basic-synthesis = 作業
basic-touch = 加工
masters-mend = マスターズメンド
hasty-touch = ヘイスティタッチ
rapid-synthesis = 突貫作業
observe = 経過観察
tricks-of-the-trade = 秘訣
waste-not = 倹約
veneration = ヴェネレーション
standard-touch = 中級加工
great-strides = グレートストライド
innovation = イノベーション
final-appraisal = 最終確認
waste-not-ii = 長期倹約
byregot-s-blessing = ビエルゴの祝福
precise-touch = 集中加工
muscle-memory = 確信
careful-synthesis = 模範作業
manipulation = マニピュレーション
prudent-touch = 倹約加工
reflect = 真価
preparatory-touch = 下地加工
groundwork = 下地作業
delicate-synthesis = 精密作業
intensive-synthesis = 集中作業
trained-eye = 匠の早業
advanced-touch = 上級加工
prudent-synthesis = 倹約作業
trained-finesse = 匠の神業
careful-observation = 設計変更
heart-and-soul = 一心不乱
refined-touch = 洗練加工
daring-touch = デアリングタッチ
immaculate-mend = パーフェクトメンド
quick-innovation = クイックイノベーション
trained-perfection = 匠の絶技

desc-immaculate-mend = 耐久を全回復する。
desc-trained-perfection = 一度だけ、アクションによる耐久の消費が0になる。一回の製作/製作練習につき1回まで使用可能

normal = 通常
good = 高品質
excellent = 最高品質
poor = 低品質
centered = 安定
sturdy = 頑丈
pliant = 高能率
malleable = 高進捗
primed = 長持続
goodomen = 良兆候

update-available = 利用可能なアップデート: v{ $version }
update-now = 今すぐ更新
update-not-now = 今じゃない
update-installing = 更新中です。しばらくお待ちください。
update-ask-relaunch = アップデートがインストールされています。アプリケーションを再起動しますか？

update-pending = 更新中
update-error = 更新に失敗しました: { $error }
update-done = 更新完了
update-uptodate = すでに最新バージョン

update-started = アップデートダウンロード開始
update-progress = 更新ダウンロード中：{ $progress }
update-done = 更新ダウンロード終了

# Titles
attributes = 属性
settings = 設定
title = { $recipe } （模拟器模式）
bill-of-material = 材料リスト
